const SuccessFull = () => {
  return (
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_diii_27400_79828)">
        <g clipPath="url(#clip0_27400_79828)">
          <rect x="8" y="4" width="64" height="64" rx="32" fill="#35BD29" />
          <rect x="8" y="4" width="64" height="64" rx="32" fill="url(#paint0_linear_27400_79828)" />
          <g opacity="0.4">
            <path
              d="M32.7026 12.6775C32.3362 11.3127 30.9266 10.4903 29.605 10.9911C23.6104 13.2596 18.6849 17.6941 15.8018 23.4183C15.165 24.6823 15.8354 26.1703 17.1554 26.6759C18.4754 27.1831 19.9426 26.5143 20.6114 25.2679C22.8646 21.0586 26.5178 17.7687 30.9394 15.9671C32.2498 15.4327 33.0674 14.0439 32.7026 12.6791V12.6775Z"
              fill="#F2F6FF"
            />
          </g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M39.7134 47.1429C45.3941 47.1429 49.9992 42.5378 49.9992 36.8572V30.3521C49.9992 28.9899 49.1928 27.7569 47.9448 27.211L41.0877 24.211C40.2116 23.8277 39.2153 23.8277 38.3392 24.211L31.4821 27.211C30.2341 27.7569 29.4277 28.9899 29.4277 30.3521V36.8572C29.4277 42.5378 34.0328 47.1429 39.7134 47.1429ZM43.9501 34.2367C44.3965 33.7904 44.3965 33.0668 43.9501 32.6205C43.5038 32.1741 42.7802 32.1741 42.3339 32.6205L38.5706 36.3838L37.093 34.9062C36.6467 34.4599 35.9231 34.4599 35.4768 34.9062C35.0304 35.3525 35.0304 36.0761 35.4768 36.5224L37.7625 38.8081C38.2088 39.2544 38.9324 39.2544 39.3787 38.8081L43.9501 34.2367Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_diii_27400_79828"
          x="-9.53674e-07"
          y="-4"
          width="80"
          height="84"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_27400_79828" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_27400_79828"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-4" dy="-4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_27400_79828" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect3_innerShadow_27400_79828"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.411765 0 0 0 0 0.0329411 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_27400_79828"
            result="effect3_innerShadow_27400_79828"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-8" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.94902 0 0 0 0 0.992157 0 0 0 0 0.964706 0 0 0 0.35 0"
          />
          <feBlend
            mode="normal"
            in2="effect3_innerShadow_27400_79828"
            result="effect4_innerShadow_27400_79828"
          />
        </filter>
        <linearGradient
          id="paint0_linear_27400_79828"
          x1="40"
          y1="4"
          x2="40"
          y2="68"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.16" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_27400_79828">
          <rect x="8" y="4" width="64" height="64" rx="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SuccessFull
